import React, {Component} from 'react';

class Score extends Component{
	render(){
		const unlockedWords = this.props.levels.slice(0, this.props.unlockedLevel).map((val) => { return val.words.length}).reduce((a, b) => a + b, 0);
		return(
			<div className="score-header">
				<div className="score-wrap">
					<div className="score-holder">
							{"Hanja " + this.props.unlockedLevel }
					</div>
					<div className="score-holder">
							 {"Words " + unlockedWords }
					</div>
					<div className="clear" />
				</div>
			</div>
		)
	}
}
export default Score;



// WEBPACK FOOTER //
// ./src/components/score.js